import { render, staticRenderFns } from "./PanelSubTabBarV2026.vue?vue&type=template&id=3177f20c&scoped=true"
import script from "./PanelSubTabBarV2026.vue?vue&type=script&lang=js"
export * from "./PanelSubTabBarV2026.vue?vue&type=script&lang=js"
import style0 from "./PanelSubTabBarV2026.vue?vue&type=style&index=0&id=3177f20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3177f20c",
  null
  
)

export default component.exports